import { ReactElement } from 'react';
import { ComponentThemeWrapper, ThemeWrapperProps } from '@vds/components';

interface CreateLayoutOptions {
    Layout?: React.ComponentType<{ children: ReactElement }>;
    theme?: ThemeWrapperProps['theme'];
}

export type GetLayout = (page: ReactElement) => JSX.Element;

export default function createLayout({
    Layout,
    theme = 'dark',
}: CreateLayoutOptions = {}): GetLayout {
    return function getLayout(Page: ReactElement): JSX.Element {
        return (
            <ComponentThemeWrapper
                styles={{ minHeight: '100dvh' }}
                theme={Page.props.VDSTheme ?? theme}
                useContainer={false}>
                {Layout ? <Layout {...Page.props}>{Page}</Layout> : Page}
            </ComponentThemeWrapper>
        );
    };
}
